<py-article-image class="mr-4" [loading]="true"></py-article-image>
<py-article-info></py-article-info>
